import * as Dialog from '@radix-ui/react-dialog';
import { useState } from 'react';
import {
    AddNewStation
  } from '../api_controll/apiAdmin';
  import { toast } from 'react-toastify';
  import {
    CURRENCY_DISPLAY_MODE_OPTIONS,
    normalizeCurrencyDisplayMode,
  } from '../utils/currencyDisplayMode';

export default function AddStationModal( { onStationAdded, existingStations  }) {
const [open, setOpen] = useState(false);
const [isArmex, setIsArmex] = useState(false);

const [formData, setFormData] = useState({
  name: '',
  location: '',
  armexId: '',
  currency_display_mode: 'both',
});

 const handleChangeStation = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  
  const handleSubmitStation = async (e) => {
    e.preventDefault();
  
    const trimmedName = formData.name.trim().toLowerCase();
  
    if (!formData.name || !formData.location) {
      toast.error("Prosím vyplňte název a lokalitu!");
      return;
    }
  
    if (isArmex && !formData.armexId) {
      toast.error("Prosím vyplňte Armex ID pro Armex stanici!");
      return;
    }
  
    const exists = existingStations.some(
      (station) => station.station_name?.trim().toLowerCase() === trimmedName
    );
  
    if (exists) {
      toast.error("Stanice s tímto názvem už existuje!");
      return;
    }
  
    const data = {
      name: formData.name.trim(),
      location: formData.location.trim(),
      currency_display_mode: normalizeCurrencyDisplayMode(formData.currency_display_mode),
      is_armex: isArmex,
      armex_id: isArmex ? formData.armexId : null,
    };
  
    try {
      await AddNewStation(data);
      onStationAdded();
      toast.success("Stanice úspěšně přidána!");
      setOpen(false);
    } catch (error) {
      toast.error("Chyba při vytváření stanice");
    }
  };
  




return (
<Dialog.Root open={open} onOpenChange={setOpen}>

<Dialog.Trigger asChild>
      <button className="admin-stations-page__add-btn"  >+ Přidat novou stanici</button>

      </Dialog.Trigger>

<Dialog.Portal>
  <Dialog.Overlay className="modal-overlay" />
  <Dialog.Content className="modal-content">
    <Dialog.Close className="modal-close">✕</Dialog.Close>
    <h2>Přidat novou čerpací stanici</h2>

    <div className="modal-form">
      <label>
        Název ČS:
        <input name="name" value={formData.name} onChange={handleChangeStation} />
      </label>

      <label>
        Lokalita:
        <input name="location" value={formData.location} onChange={handleChangeStation} />
      </label>
 <label>
      Zobrazení cen:
        <select
          name="currency_display_mode"
          value={formData.currency_display_mode ?? "both"}
          onChange={handleChangeStation}
            style={{
          marginLeft: '8px',
          padding: '4px 8px',
          borderRadius: '4px',
          border: '1px solid #ccc',
          fontSize: '14px',
        }}
        >
          {CURRENCY_DISPLAY_MODE_OPTIONS.map(({ value, label }) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>
      </label>
      <label className="modal-checkbox checkbox-label">
      Armex ČS

        <input
          type="checkbox"
          checked={isArmex}
          onChange={() => setIsArmex((prev) => !prev)}
        />
      </label>

      {isArmex && (
        <label>
          Armex ID:
          <input
            name="armexId"
            type="number"
            value={formData.armexId}
            onChange={handleChangeStation}
          />
        </label>
      )}

      <button className="modal-save-btn" onClick={handleSubmitStation}>Uložit</button>
    </div>
  </Dialog.Content>
</Dialog.Portal>
</Dialog.Root>

);
}
